import { render, staticRenderFns } from "./QuestionNoimgAb.vue?vue&type=template&id=8bd8462c&"
import script from "./QuestionNoimgAb.vue?vue&type=script&lang=ts&"
export * from "./QuestionNoimgAb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports